"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Module = window.Module;
var CanvasRender = (function () {
    function CanvasRender(wrapperId) {
        this.density = 1;
        this.bgColor = '';
        this.currentScale = 1;
        this.isMoveField = false;
        this.wrapperId = '';
        this.isLocked = false;
        this.wrapperId = wrapperId;
        this.wrapper = document.querySelector("#" + wrapperId);
        this.canvas = document.createElement('canvas');
        this.wrapper.appendChild(this.canvas);
        this.ctx = this.canvas.getContext('2d');
        this.canvas.width = window.innerWidth;
        this.canvas.height = window.innerHeight;
        this.wrapper.style.width = window.innerWidth + 'px';
        this.wrapper.style.height = window.innerHeight + 'px';
        this.width = this.wrapper.clientWidth;
        this.height = this.wrapper.clientHeight;
        var rect = {
            width: 0,
            height: 0
        };
        rect.width = this.width;
        rect.height = this.height;
        if (!rect.width && !rect.height) {
            rect = this.canvas.getBoundingClientRect();
        }
        this.halfWidth = rect.width / 2;
        this.halfHeight = rect.height / 2;
        this.ctx.imageSmoothingEnabled = true;
        this.ctx.mozImageSmoothingEnabled = true;
        this.ctx.webkitImageSmoothingEnabled = true;
        this.ctx.msImageSmoothingEnabled = true;
        this.ctx.imageSmoothingQuality = 'high';
    }
    CanvasRender.prototype.setGameControl = function (gc) {
        this.gameControl = gc;
    };
    CanvasRender.prototype.renderFigures = function () {
        if (!this.gameControl) {
            return;
        }
        this.clearCanvas();
        this.gameControl.redrawGameObjects();
        var type = {};
        var gameObj = null;
        do {
            type = this.gameControl.popGameObject();
            switch (type) {
                case Module.GameObjectType.GameLineType:
                    gameObj = this.gameControl.popGameLineObject();
                    this.renderGameLine(gameObj);
                    break;
                case Module.GameObjectType.GameArcType:
                    gameObj = this.gameControl.popGameArcObject();
                    this.renderGameArc(gameObj);
                    break;
                case Module.GameObjectType.GamePointType:
                    gameObj = this.gameControl.popGamePointObject();
                    this.renderGamePoint(gameObj);
                    break;
                case Module.GameObjectType.GameLabelType:
                    gameObj = this.gameControl.popGameLabelObject();
                    this.renderGameLabel(gameObj);
                    break;
            }
        } while (type != Module.GameObjectType.GameEmptyType);
    };
    CanvasRender.prototype.clearCanvas = function () {
        if (this.ctx) {
            this.ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
        }
    };
    CanvasRender.prototype.renderGamePoint = function (point) {
        if (this.ctx) {
            this.ctx.setLineDash([]);
            this.ctx.beginPath();
            this.ctx.arc(point.coord.x, point.coord.y, point.radius, 0, 2 * Math.PI, false);
            this.ctx.fillStyle = this._colorFromString(point.color);
            this.ctx.fill();
            if (point.borderWidth != 0) {
                this.ctx.lineWidth = point.borderWidth;
                this.ctx.strokeStyle = this._colorFromString(point.borderColor);
                this.ctx.stroke();
            }
            this.ctx.closePath();
        }
    };
    ;
    CanvasRender.prototype.renderGameLine = function (line) {
        if (this.ctx) {
            if (line.dash.length != 0) {
                this.ctx.setLineDash(this._extractDashPatternFromString(line.dash));
            }
            else {
                this.ctx.setLineDash([]);
            }
            this.ctx.beginPath();
            this.ctx.moveTo(line.startCoord.x, line.startCoord.y);
            this.ctx.lineTo(line.endCoord.x, line.endCoord.y);
            this.ctx.lineWidth = line.width;
            this.ctx.strokeStyle = this._colorFromString(line.color);
            this.ctx.stroke();
            this.ctx.closePath();
        }
    };
    ;
    CanvasRender.prototype.renderGameArc = function (arc) {
        if (this.ctx) {
            if (arc.dash.length != 0) {
                this.ctx.setLineDash(this._extractDashPatternFromString(arc.dash));
            }
            else {
                this.ctx.setLineDash([]);
            }
            this.ctx.beginPath();
            this.ctx.arc(arc.centerCoord.x, arc.centerCoord.y, arc.radius, arc.startAngle, arc.endAngle, arc.clockwise);
            this.ctx.lineWidth = arc.width;
            this.ctx.strokeStyle = this._colorFromString(arc.color);
            this.ctx.stroke();
            this.ctx.closePath();
        }
    };
    ;
    CanvasRender.prototype.renderGameLabel = function (label) {
        if (this.ctx) {
            var color = label.fontColor ? this._colorFromString(label.fontColor) : this._colorFromString("255 255 255");
            var coords = label.coord;
            var textSize = label.fontSize > 0 ? label.fontSize : 17;
            coords.y += textSize;
            var textStyle = label.fontName ? label.fontName : "Open Sans";
            this.ctx.beginPath();
            this.ctx.fillStyle = color;
            this.ctx.font = textSize + "px " + textStyle;
            this.ctx.fillText(label.text, coords.x, coords.y);
            this.ctx.stroke();
            this.ctx.closePath();
        }
    };
    ;
    CanvasRender.prototype._colorFromString = function (colorStr) {
        var components = colorStr.split(" ");
        if (components.length < 3 || components.length > 4) {
            return '';
        }
        var red = components[0];
        var green = components[1];
        var blue = components[2];
        var alpha = components.length == 4 ? components[3] : 1;
        return 'rgba(' + red + ',' + green + ',' + blue + ',' + alpha + ')';
    };
    ;
    CanvasRender.prototype._extractDashPatternFromString = function (dashPatternStr) {
        if (dashPatternStr == undefined || dashPatternStr.length == 0)
            return [0];
        var arr = dashPatternStr.split(",");
        return arr.map(function (el) {
            return parseFloat(el);
        });
    };
    ;
    CanvasRender.prototype.setOnTouchListener = function (gameView) {
        var self = this;
        var isMoving = false;
        var isMousedown = false;
        var startCoord = { x: 0, y: 0 };
        var prevCoord = { x: 0, y: 0 };
        var trackLen = 0;
        var isHoverLocked = false;
        this.canvas.addEventListener('mousemove', onHover);
        this.canvas.addEventListener('mousedown', onMouseDown);
        function getCoords(evt) {
            return {
                x: evt.pageX,
                y: evt.pageY
            };
        }
        window.onkeydown = function (e) {
            if (self.isLocked) {
                return true;
            }
            var center = { x: self.halfWidth, y: self.halfHeight };
            var key = e.keyCode;
            var modalDescription = document.querySelector('.js-modal-description');
            var modalHelp = document.querySelector('.js-modal-help');
            var modalSuccess = document.querySelector('.js-modal-success');
            var modalHelpAddon = document.querySelectorAll('.js-modal-help-addon');
            var isModalDescriptionActive = modalDescription && modalDescription.classList.contains('active');
            var isModalHelpActive = modalHelp && modalHelp.classList.contains('active');
            var isModalSuccessActive = modalSuccess && modalSuccess.classList.contains('active');
            var isModalHelpAddonActive;
            if (modalHelpAddon) {
                for (var _i = 0, modalHelpAddon_1 = modalHelpAddon; _i < modalHelpAddon_1.length; _i++) {
                    var modal = modalHelpAddon_1[_i];
                    if (modal.classList.contains('active')) {
                        isModalHelpAddonActive = true;
                    }
                }
            }
            var isLayoutActive = isModalDescriptionActive || isModalHelpActive || isModalSuccessActive || isModalHelpAddonActive;
            if (isLayoutActive) {
                return;
            }
            switch (key) {
                case 38:
                    gameView.moveField(center, Module.MoveState.MoveStateBegan);
                    gameView.moveField({ x: center.x, y: center.y - 10 }, Module.MoveState.MoveStateChanged);
                    gameView.moveField({ x: center.x, y: center.y - 10 }, Module.MoveState.MoveStateEnded);
                    break;
                case 39:
                    gameView.moveField(center, Module.MoveState.MoveStateBegan);
                    gameView.moveField({ x: center.x + 10, y: center.y }, Module.MoveState.MoveStateChanged);
                    gameView.moveField({ x: center.x + 10, y: center.y }, Module.MoveState.MoveStateEnded);
                    break;
                case 37:
                    gameView.moveField(center, Module.MoveState.MoveStateBegan);
                    gameView.moveField({ x: center.x - 10, y: center.y }, Module.MoveState.MoveStateChanged);
                    gameView.moveField({ x: center.x - 10, y: center.y }, Module.MoveState.MoveStateEnded);
                    break;
                case 40:
                    gameView.moveField(center, Module.MoveState.MoveStateBegan);
                    gameView.moveField({ x: center.x, y: center.y + 10 }, Module.MoveState.MoveStateChanged);
                    gameView.moveField({ x: center.x, y: center.y + 10 }, Module.MoveState.MoveStateEnded);
                    break;
                case 27:
                    gameView.resetToolType();
                    break;
            }
        };
        function onMouseDown(evt) {
            isHoverLocked = true;
            var coord = getCoords(evt);
            if (evt.button == 0) {
                isMousedown = true;
                if (gameView.toolType() == 'HandTool' && gameView.checkHandCursor(coord)) {
                    self.isMoveField = true;
                    self.wrapper.style.cursor = 'move';
                }
            }
            startCoord = coord;
            prevCoord = coord;
            trackLen = 0;
            if (isMousedown && evt.button == 2 && !self.isLocked) {
                gameView.resetToolType();
                isMousedown = false;
            }
            else if (!isMousedown && evt.button == 2 && !self.isLocked) {
                if (isMoving) {
                    gameView.resetToolType();
                }
                self.canvas.addEventListener('mousemove', onMove);
                self.canvas.addEventListener('mouseup', onUp);
            }
            else if (!self.isLocked) {
                self.canvas.addEventListener('mousemove', onMouseMove);
                self.canvas.addEventListener('mouseup', onMouseUp);
            }
            self.canvas.addEventListener('contextmenu', contextMenu);
        }
        function onHover(evt) {
            var coord = getCoords(evt);
            if (!isHoverLocked) {
                gameView.hover(coord);
            }
        }
        function contextMenu(event) {
            event.preventDefault();
            self.canvas.removeEventListener('contextmenu', contextMenu);
        }
        function onMove(evt) {
            self.wrapper.style.cursor = 'move';
            var coords = getCoords(evt);
            if (!isMoving) {
                gameView.moveField(startCoord, Module.MoveState.MoveStateBegan);
                isMoving = true;
            }
            else {
                gameView.moveField(coords, Module.MoveState.MoveStateChanged);
            }
        }
        function onUp(evt) {
            var coords = getCoords(evt);
            self.canvas.removeEventListener('mousemove', onMove);
            if (startCoord.x == coords.x && startCoord.y == coords.y) {
                gameView.resetToolType();
            }
            if (isMoving) {
                gameView.moveField(coords, Module.MoveState.MoveStateEnded);
                isMoving = false;
            }
            self.canvas.removeEventListener('mouseup', onUp);
            self.wrapper.style.cursor = 'default';
            isHoverLocked = false;
        }
        function onMouseMove(evt) {
            var coords = getCoords(evt);
            if (!isMoving) {
                if (trackLen > 0) {
                    gameView.move(startCoord, Module.MoveState.MoveStateBegan);
                    isMoving = true;
                }
                else {
                    trackLen += distanceBetweenCoords(prevCoord, coords);
                    prevCoord = coords;
                }
            }
            else {
                gameView.move(coords, Module.MoveState.MoveStateChanged);
            }
        }
        function onMouseUp(evt) {
            if (self.isMoveField) {
                self.isMoveField = false;
                self.wrapper.style.cursor = 'default';
            }
            var coords = getCoords(evt);
            self.canvas.removeEventListener('mousemove', onMouseMove);
            if (isMoving) {
                gameView.move(coords, Module.MoveState.MoveStateEnded);
                isMoving = false;
            }
            else {
                gameView.tapped(coords);
            }
            self.canvas.removeEventListener('mouseup', onMouseUp);
            isMousedown = false;
            isHoverLocked = false;
        }
        CanvasRender.prototype.deleteOnTouchListener = function () {
            this.canvas.removeEventListener('mousemove', onMouseMove);
            this.canvas.removeEventListener('mousemove', onHover);
            this.canvas.removeEventListener('mousedown', onMouseDown);
            this.canvas.removeEventListener('mouseup', onMouseUp);
            this.canvas.removeEventListener('contextmenu', contextMenu);
        };
    };
    CanvasRender.prototype.setWheelListener = function (gameView) {
        this.canvas.addEventListener('wheel', onWheel);
        function onWheel(e) {
            var coords = {
                x: e.pageX,
                y: e.pageY
            };
            var scale = 1;
            gameView.scaleField(scale, coords, Module.MoveState.MoveStateBegan);
            if (e.deltaY < 0) {
                scale += 0.1;
            }
            else {
                scale -= 0.1;
            }
            gameView.scaleField(scale, coords, Module.MoveState.MoveStateChanged);
            gameView.scaleField(scale, coords, Module.MoveState.MoveStateEnded);
            this.currentScale = scale;
            e.preventDefault();
        }
        CanvasRender.prototype.deleteWheelListener = function () {
            this.canvas.removeEventListener('wheel', onWheel);
        };
    };
    CanvasRender.prototype.deleteWheelListener = function () {
    };
    CanvasRender.prototype.deleteOnTouchListener = function () {
    };
    CanvasRender.prototype.lockScene = function (lock) {
        this.isLocked = lock || false;
    };
    CanvasRender.prototype.remove = function () {
        this.deleteOnTouchListener();
        this.deleteWheelListener();
        delete this.ctx;
        this.canvas.parentNode.removeChild(this.canvas);
        delete this.canvas;
    };
    return CanvasRender;
}());
exports.CanvasRender = CanvasRender;
function distanceBetweenCoords(coord1, coord2) {
    return Math.abs(Math.sqrt(Math.pow(coord1.x - coord2.x, 2) + Math.pow(coord1.y - coord2.y, 2)));
}



//////////////////
// WEBPACK FOOTER
// ./src/renders/canvasRender.ts
// module id = 258
// module chunks = 0